import axios from 'axios';
import {
  GET_GROUPS, ADD_GROUP, DELETE_GROUP, UPDATE_GROUP, GROUPS_LOADING,
  UPDATE_PROGRAM
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getGroups = () => (dispatch, getState) => {
  dispatch({ type: GROUPS_LOADING });
  axios
    .get('/api/groups', tokenConfig(getState))
    .then(res => dispatch({ type: GET_GROUPS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addGroup = group => (dispatch, getState) => {
  return axios
    .post('/api/groups', group, tokenConfig(getState))
    .then(res => {
      dispatch({ type: ADD_GROUP, payload: res.data });
      
      // If the group has a program, fetch the updated program to reflect the new group
      if (res.data.program && res.data.program._id) {
        axios
          .get(`/api/programs/${res.data.program._id}`, tokenConfig(getState))
          .then(programRes => {
            dispatch({ type: UPDATE_PROGRAM, payload: programRes.data });
          })
          .catch(err => dispatch(returnErrors(err.response.data, err.response.status, 'GET_PROGRAM_FAIL')));
      }
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err;
    });
};

export const updateGroup = (id, group) => (dispatch, getState) => {
  return axios
    .put(`/api/groups/${id}`, group, tokenConfig(getState))
    .then(res => {
      dispatch({ type: UPDATE_GROUP, payload: res.data });
      
      // If the group has a program, fetch the updated program
      if (res.data.program && res.data.program._id) {
        axios
          .get(`/api/programs/${res.data.program._id}`, tokenConfig(getState))
          .then(programRes => {
            dispatch({ type: UPDATE_PROGRAM, payload: programRes.data });
          })
          .catch(err => dispatch(returnErrors(err.response.data, err.response.status, 'GET_PROGRAM_FAIL')));
      }
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err;
    });
};

export const deleteGroup = id => (dispatch, getState) => {
  // First get the group to find its program
  axios
    .get(`/api/groups`, tokenConfig(getState))
    .then(groupsRes => {
      const groupToDelete = groupsRes.data.find(g => g._id === id);
      const programId = groupToDelete?.program?._id || groupToDelete?.program;
      
      // Delete the group
      axios
        .delete(`/api/groups/${id}`, tokenConfig(getState))
        .then(res => {
          dispatch({ type: DELETE_GROUP, payload: id });
          
          // If the group had a program, fetch the updated program
          if (programId) {
            axios
              .get(`/api/programs/${programId}`, tokenConfig(getState))
              .then(programRes => {
                dispatch({ type: UPDATE_PROGRAM, payload: programRes.data });
              })
              .catch(err => dispatch(returnErrors(err.response.data, err.response.status, 'GET_PROGRAM_FAIL')));
          }
        })
        .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
    })
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};
